module.exports = __webpack_public_path__ + "assets/img/mangguoke_519_2.04472c9a.jpg";